import Lottie from 'lottie-react';

export { Lottie as Lottie };
export * from 'lottie-react';
